import { useState } from "react";
import { IconButton, Toolbar, Typography } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AppBar from "@mui/material/AppBar";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { logout } from "../../../features/auth/authSlice";
import { useAppDispatch } from "../../../app/hooks";
import { setDealerId } from "../../../features/dealer/dealerSlice";
import { useNavigate } from "react-router-dom";
import { useSaveUserPreferencesIfChanged } from "../../../common/UserPreference/hooks/userPreferenceshook";

type Props = {
  menu?: boolean;
};

const Header = (props: Props) => {
  const { menu } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const savePreferenceIfChanged = useSaveUserPreferencesIfChanged();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    
    //1. Save Preference first
    await savePreferenceIfChanged();

    //2. clear app session
    dispatch(logout());
    dispatch(setDealerId(""));
    localStorage.clear();
    sessionStorage.clear();

    //3. Redirect
    navigate("/");
  };

  return (
    <AppBar position="fixed">
      <Toolbar>
        {/* <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton> */}

        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          {/*TargetPay*/}
        </Typography>

        {menu && (
          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleClick}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
              <MenuItem onClick={handleClose}>My account</MenuItem> */}
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
